export const RESET_PRODUCT_ISFETCHING = 'RESET_PRODUCT_ISFETCHING';
export const GET_PRODUCT_BY_SKU_REQUEST = 'GET_PRODUCT_BY_SKU_REQUEST';
export const GET_PRODUCT_REQUEST = 'GET_PRODUCT_REQUEST';
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const LIST_PRODUCTS_REQUEST = 'LIST_PRODUCTS_REQUEST';
export const PRODUCT_REQUESTING = 'PRODUCT_REQUESTING';
export const LIST_PRODUCTS_SUCCESS = 'LIST_PRODUCTS_SUCCESS';

export const LIST_PRODUCTS_SUCCESS_GTM = 'LIST_PRODUCTS_SUCCESS_GTM';
export const GET_PRODUCT_SUCCESS_GTM = 'GET_PRODUCT_SUCCESS_GTM';

export const PRODUCT_CLICK_SUCCESS_GTM = 'PRODUCT_CLICK_SUCCESS_GTM';
